import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSettingSpecialHolidayNet90TimeRange, getSettingSpecialHolidayNet90Timezone, specialHolidayNet90Active } from "@faire/retailer-visitor-shared/settings/getSettingSpecialHolidayNet90";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { intlDateWithTimezone } from "@faire/web--source/common/localization/date-fns/intlDate";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import addDays from "date-fns/addDays";
import differenceInHours from "date-fns/differenceInHours";
import differenceInMinutes from "date-fns/differenceInMinutes";
import { observer } from "mobx-react";
import React from "react";
var PromoTextScenario;
(function(PromoTextScenario) {
    PromoTextScenario[PromoTextScenario["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    PromoTextScenario[PromoTextScenario["ACTIVE_TERMS_ELIGIBLE_LONG"] = 1] = "ACTIVE_TERMS_ELIGIBLE_LONG";
    PromoTextScenario[PromoTextScenario["ACTIVE_TERMS_ELIGIBLE_SHORT"] = 2] = "ACTIVE_TERMS_ELIGIBLE_SHORT";
    PromoTextScenario[PromoTextScenario["ACTIVE_NO_TERMS_LONG"] = 3] = "ACTIVE_NO_TERMS_LONG";
    PromoTextScenario[PromoTextScenario["ACTIVE_NO_TERMS_SHORT"] = 4] = "ACTIVE_NO_TERMS_SHORT";
    PromoTextScenario[PromoTextScenario["EXPIRING_TERMS_ELIGIBLE_LONG"] = 5] = "EXPIRING_TERMS_ELIGIBLE_LONG";
    PromoTextScenario[PromoTextScenario["EXPIRING_TERMS_ELIGIBLE_SHORT"] = 6] = "EXPIRING_TERMS_ELIGIBLE_SHORT";
    PromoTextScenario[PromoTextScenario["EXPIRING_NO_TERMS_LONG"] = 7] = "EXPIRING_NO_TERMS_LONG";
    PromoTextScenario[PromoTextScenario["EXPIRING_NO_TERMS_SHORT"] = 8] = "EXPIRING_NO_TERMS_SHORT";
})(PromoTextScenario || (PromoTextScenario = {}));
var SpecialHolidayNet90PromoBannerBase = function() {
    var _getSettingSpecialHolidayNet90TimeRange_end_at;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isExtensionLaunched = !!getSettingSpecialHolidayNet90Timezone();
    var _getSettingSpecialHolidayNet90TimeRange_end_at_seconds;
    var endTime = ((_getSettingSpecialHolidayNet90TimeRange_end_at_seconds = (_getSettingSpecialHolidayNet90TimeRange_end_at = getSettingSpecialHolidayNet90TimeRange().end_at) === null || _getSettingSpecialHolidayNet90TimeRange_end_at === void 0 ? void 0 : _getSettingSpecialHolidayNet90TimeRange_end_at.seconds) !== null && _getSettingSpecialHolidayNet90TimeRange_end_at_seconds !== void 0 ? _getSettingSpecialHolidayNet90TimeRange_end_at_seconds : 0) * 1000;
    var endDateText = !getSettingSpecialHolidayNet90Timezone() ? strictLocalize({
        id: "kQHWWZ",
        defaultMessage: [
            {
                type: 0,
                value: "Oct 10"
            }
        ]
    }) : intlDateWithTimezone(endTime, "MMM d", getSettingSpecialHolidayNet90Timezone());
    var hoursLeft = differenceInHours(endTime, new Date());
    var minutesLeft = Math.max(differenceInMinutes(endTime, new Date()), 1);
    var textPrefix = function() {
        if (!specialHolidayNet90Active()) {
            return null;
        }
        if (hoursLeft < 1) {
            return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "b/MxDR",
                    defaultMessage: [
                        {
                            type: 6,
                            value: "minutes",
                            options: {
                                one: {
                                    value: [
                                        {
                                            type: 1,
                                            value: "minutes"
                                        },
                                        {
                                            type: 0,
                                            value: " minute left!"
                                        }
                                    ]
                                },
                                other: {
                                    value: [
                                        {
                                            type: 1,
                                            value: "minutes"
                                        },
                                        {
                                            type: 0,
                                            value: " minutes left!"
                                        }
                                    ]
                                }
                            },
                            offset: 0,
                            pluralType: "cardinal"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        minutes: minutesLeft
                    })
                }),
                tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "8qFvHd",
                    defaultMessage: [
                        {
                            type: 6,
                            value: "minutes",
                            options: {
                                one: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Only "
                                        },
                                        {
                                            type: 1,
                                            value: "minutes"
                                        },
                                        {
                                            type: 0,
                                            value: " minute left!"
                                        }
                                    ]
                                },
                                other: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Only "
                                        },
                                        {
                                            type: 1,
                                            value: "minutes"
                                        },
                                        {
                                            type: 0,
                                            value: " minutes left!"
                                        }
                                    ]
                                }
                            },
                            offset: 0,
                            pluralType: "cardinal"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        minutes: minutesLeft
                    })
                })
            });
        }
        if (hoursLeft < 24) {
            return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Ul7bE6",
                    defaultMessage: [
                        {
                            type: 6,
                            value: "hoursLeft",
                            options: {
                                one: {
                                    value: [
                                        {
                                            type: 1,
                                            value: "hoursLeft"
                                        },
                                        {
                                            type: 0,
                                            value: " hour left!"
                                        }
                                    ]
                                },
                                other: {
                                    value: [
                                        {
                                            type: 1,
                                            value: "hoursLeft"
                                        },
                                        {
                                            type: 0,
                                            value: " hours left!"
                                        }
                                    ]
                                }
                            },
                            offset: 0,
                            pluralType: "cardinal"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        hoursLeft: hoursLeft
                    })
                }),
                tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "exGdrh",
                    defaultMessage: [
                        {
                            type: 6,
                            value: "hoursLeft",
                            options: {
                                one: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Only "
                                        },
                                        {
                                            type: 1,
                                            value: "hoursLeft"
                                        },
                                        {
                                            type: 0,
                                            value: " hour left!"
                                        }
                                    ]
                                },
                                other: {
                                    value: [
                                        {
                                            type: 0,
                                            value: "Only "
                                        },
                                        {
                                            type: 1,
                                            value: "hoursLeft"
                                        },
                                        {
                                            type: 0,
                                            value: " hours left!"
                                        }
                                    ]
                                }
                            },
                            offset: 0,
                            pluralType: "cardinal"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        hoursLeft: hoursLeft
                    })
                })
            });
        }
        if (isExtensionLaunched) {
            return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "3A7XN7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Limited time only!"
                        }
                    ]
                })
            });
        }
        return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            mobile: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "87yc1k",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Holiday buying is here!"
                    }
                ]
            }),
            tabletAndAbove: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "/1wetA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Holiday special!"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    hoursLeft: hoursLeft
                })
            })
        });
    };
    var scenario = function(isTabletAndAbove) {
        if (!specialHolidayNet90Active()) {
            return PromoTextScenario.NOT_APPLICABLE;
        }
        var prefix = hoursLeft < 24 ? "EXPIRING_" : "ACTIVE_";
        var termsEligibility = !isLoggedInRetailer() || RetailerStore.get().isRetailerOnNetTerms ? "TERMS_ELIGIBLE" : "NO_TERMS";
        var postfix = isTabletAndAbove ? "_LONG" : "_SHORT";
        var _PromoTextScenario_;
        return (_PromoTextScenario_ = PromoTextScenario["".concat(prefix).concat(termsEligibility).concat(postfix)]) !== null && _PromoTextScenario_ !== void 0 ? _PromoTextScenario_ : PromoTextScenario.NOT_APPLICABLE;
    };
    var textBody = function(isTabletAndAbove) {
        if (isExtensionLaunched) {
            switch(scenario(isTabletAndAbove)){
                case PromoTextScenario.ACTIVE_TERMS_ELIGIBLE_LONG:
                case PromoTextScenario.EXPIRING_TERMS_ELIGIBLE_LONG:
                case PromoTextScenario.ACTIVE_TERMS_ELIGIBLE_SHORT:
                    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "7w3dcS",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Buy now, pay 90 days later\u2014now through "
                            },
                            {
                                type: 1,
                                value: "endDateText"
                            },
                            {
                                type: 0,
                                value: "."
                            }
                        ],
                        values: DEPRECATED_backwardsCompatibleValues({
                            endDateText: endDateText
                        })
                    });
                case PromoTextScenario.EXPIRING_TERMS_ELIGIBLE_SHORT:
                    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "NFaJeN",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Buy now, pay 90 days later."
                            }
                        ]
                    });
                case PromoTextScenario.ACTIVE_NO_TERMS_LONG:
                case PromoTextScenario.EXPIRING_NO_TERMS_LONG:
                    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ktGt8D",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Enjoy extended 90-day returns on all opening orders\u2014now through "
                            },
                            {
                                type: 1,
                                value: "endDateText"
                            },
                            {
                                type: 0,
                                value: "."
                            }
                        ],
                        values: DEPRECATED_backwardsCompatibleValues({
                            endDateText: endDateText
                        })
                    });
                case PromoTextScenario.ACTIVE_NO_TERMS_SHORT:
                    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "J7t3I2",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "90-day returns on opening orders. Offer ends soon!"
                            }
                        ]
                    });
                case PromoTextScenario.EXPIRING_NO_TERMS_SHORT:
                    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "YW3ebp",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "90-day returns on opening orders."
                            }
                        ]
                    });
                default:
                    exhaustiveSwitchWithDefault();
            }
            return undefined;
        }
        switch(scenario(isTabletAndAbove)){
            case PromoTextScenario.ACTIVE_TERMS_ELIGIBLE_LONG:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Ko7CGD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Now through "
                        },
                        {
                            type: 1,
                            value: "endDateText"
                        },
                        {
                            type: 0,
                            value: ", buy now & don't pay until "
                        },
                        {
                            type: 1,
                            value: "dueDate"
                        },
                        {
                            type: 0,
                            value: "\u2014just in time for the holiday rush."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        endDateText: endDateText,
                        dueDate: intlDate(addDays(new Date(), 90), "MMM d")
                    })
                });
            case PromoTextScenario.ACTIVE_TERMS_ELIGIBLE_SHORT:
            case PromoTextScenario.EXPIRING_TERMS_ELIGIBLE_SHORT:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "NFaJeN",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Buy now, pay 90 days later."
                        }
                    ]
                });
            case PromoTextScenario.ACTIVE_NO_TERMS_LONG:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Q1Vvyo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Now through "
                        },
                        {
                            type: 1,
                            value: "endDateText"
                        },
                        {
                            type: 0,
                            value: ", enjoy extended 90-day returns on opening orders."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        endDateText: endDateText
                    })
                });
            case PromoTextScenario.ACTIVE_NO_TERMS_SHORT:
            case PromoTextScenario.EXPIRING_NO_TERMS_SHORT:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "YW3ebp",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "90-day returns on opening orders."
                        }
                    ]
                });
            case PromoTextScenario.EXPIRING_TERMS_ELIGIBLE_LONG:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "MQIpOu",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Buy now, pay 90 days later\u2014just in time for the holiday rush."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        hoursLeft: hoursLeft
                    })
                });
            case PromoTextScenario.EXPIRING_NO_TERMS_LONG:
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "71JTCR",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enjoy extended 90-day returns on opening orders this holiday season."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        hoursLeft: hoursLeft
                    })
                });
            default:
                return undefined;
        }
    };
    // if both mobile and desktop scenarios are false
    if (scenario(true) === PromoTextScenario.NOT_APPLICABLE && scenario(false) === PromoTextScenario.NOT_APPLICABLE) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Typography, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Medium, {
                children: textPrefix()
            }),
            /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                mobile: textBody(false),
                tabletAndAbove: textBody(true)
            })
        ]
    });
};
export var SpecialHolidayNet90PromoBanner = observer(SpecialHolidayNet90PromoBannerBase);
